// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b647c6bd","389":"afd1bab0","732":"f7ab0092","977":"bc6c280c"}[chunkId] + ".chunk.js";
};